'use strict';

const shipmentMethodsPanel = {
  bindings: {
    title: '<',
    name: '<',
    price: '<',
    selected: '<',
    pieces: '<'
  },
  transclude: true,
  template: `
    <div id="panel_{{ $ctrl.name | lowercase }}" class="panel" ng-class="{ callout: $ctrl.selected }">
      <i class="fa left" ng-class="{ 'fa-check-square-o': $ctrl.selected, 'fa-square-o': !$ctrl.selected }"></i>
      <h4>
        {{ $ctrl.title }}
        <br>
        <small>{{ $ctrl.price | crowns }}</small>
        <small>{{ $ctrl.pieces }}</small>
      </h4>
    </div>

    <div ng-transclude></div>
  `
};

angular
  .module('SendRegning')
  .component('shipmentMethodsPanel', shipmentMethodsPanel);
